import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { containers } from "src/lib/db";
import {
  getSelectedContainer,
  selectContainer,
} from "src/lib/slices/drinkSelectionSlice";
import { Card, CardContent, CardHeader } from "../ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import UserAvatar from "../userAvatar";
import CustomContainer from "./CustomContainer";
import style from "./DrinkSelector.module.css";

export default function ContainerTabs({ selection, open, setOpen }) {
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);

  const containerTypes = [
    ...new Set(containers.map((container) => container.type)),
  ];

  const selectedContainer = getSelectedContainer(selection);

  const [tabsValue, setTabsValue] = useState(selectedContainer?.type);

  const getContainerIcon = (containerType: string) => {
    const container = containers.find(
      (container) => container.type === containerType
    );
    if (container) {
      return container.icon;
    }
    return "";
  };

  const getContainersByType = (containerType: string) => {
    return containers.filter((container) => container.type === containerType);
  };

  return (
    <Tabs value={tabsValue} onValueChange={setTabsValue as any}>
      <TabsList
        className={`grid w-full rounded-md ${style.tabs}`}
        style={{
          backgroundColor: "hsl(var(--muted))",
          display: "flex",
          flexWrap: "wrap",
          rowGap: "0.25rem",
          height: "fit-content",
          top: 0,
        }}
      >
        {containerTypes.map((containerType, index) => (
          <TabsTrigger value={containerType} key={containerType}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1ch",
              }}
            >
              <div
                style={{
                  width: "0.75rem",
                  height: "1rem",
                }}
              >
                <img
                  src={`/container-images/${getContainerIcon(containerType)}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    objectPosition: "center",
                  }}
                  alt=""
                />
              </div>
              <div>{containerType}</div>
            </div>
          </TabsTrigger>
        ))}
        <TabsTrigger value={"Own"} key={"Own"}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1ch",
            }}
          >
            <UserAvatar friend={user} className="h-4 w-4" /> Vlastní
          </div>
        </TabsTrigger>
      </TabsList>
      {containerTypes.map((containerType) => (
        <TabsContent
          value={containerType}
          key={containerType}
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(8rem, 1fr))",
            gridTemplateRows: "repeat(auto-fill, 1fr)",
            gap: "1rem",
          }}
          className="mt-4"
        >
          {getContainersByType(containerType).map((container) => (
            <Card
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                backgroundColor:
                  selection.containerId === container.id
                    ? "hsl(var(--primary))"
                    : "hsl(var(--muted))",
                color:
                  selection.containerId === container.id
                    ? "hsl(var(--primary-foreground))"
                    : undefined,
                cursor: "pointer",
              }}
              key={container.id}
              onClick={() => {
                dispatch(selectContainer(container.id));
                setOpen(false);
              }}
            >
              <CardHeader
                style={{
                  padding: "0.25rem",
                  textAlign: "center",
                  paddingBottom: 0,
                  fontWeight: "500",
                }}
              >
                {container.name}
              </CardHeader>
              <CardContent
                style={{
                  padding: "0.25rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "end",
                  }}
                >
                  <img
                    src={`/container-images/${container.icon}`}
                    style={{
                      height: `calc(5rem * ${container.iconSizeMultiplier})`,
                      maxWidth: "100%",
                    }}
                    alt=""
                  />
                </div>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "500",
                    fontSize: "0.75rem",
                  }}
                >
                  {container.volume} {container.units}
                </div>
              </CardContent>
            </Card>
          ))}
        </TabsContent>
      ))}
      <TabsContent value={"Own"} key={"Own"} className="mt-4">
        <div style={{ height: "300px" }}>
          <CustomContainer setOpen={setOpen} />
        </div>
      </TabsContent>
    </Tabs>
  );
}
